export default "__VITE_ASSET__CtXZ8X9c__"